import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./ContentReport.module.scss";

type Props = {
  handler: () => void;
  wrapperClass?: string;
};
const ContentReportButton: React.FC<Props> = ({ handler, wrapperClass }) => {
  return (
    <div className={wrapperClass}>
      <button type="button" onClick={handler} className={styles["c-report"]}>
        <FontAwesomeIcon icon={["fas", "megaphone"]} />
        報告
      </button>
    </div>
  );
};

export default ContentReportButton;
